import { FrameworkConfiguration, Container } from 'aurelia-framework';
import { I18N, Backend, TCustomAttribute } from 'aurelia-i18n';

export function configure(config: FrameworkConfiguration): void {
  var i18n = Container.instance.get(I18N);
  i18n.i18next.loadNamespaces(["Sample.GithubUser", "Sample.OpenLayer", "Sample.Welcome", "Sample.Common"]).then(() => {
    console.log("Load namespace Sample succeed.");
  }).catch((reason) => {
    console.log("Load namespace Sample failed. reason: " + reason)
  });
  //config.globalResources([]);
}
